export enum OngoingABTests {
    MULTILEAD_TINDER = "multilead-tinder",
    USP_LISTING_TILE = "rp-tile-usp",
    PROPERTY_FAQ_LOGGED_IN = "rp-faq-login",
    PROPERTY_FAQ_ANONYMOUS = "rp-faq-not-login"
}
export enum OngoingABTests {
    MULTILEAD_TINDER = "multilead-tinder",
    USP_LISTING_TILE = "rp-tile-usp",
    PROPERTY_FAQ_LOGGED_IN = "rp-faq-login",
    PROPERTY_FAQ_ANONYMOUS = "rp-faq-not-login"
}
